import { render, staticRenderFns } from "./Reward2LogList.vue?vue&type=template&id=c9768722&scoped=true&"
import script from "./Reward2LogList.vue?vue&type=script&lang=js&"
export * from "./Reward2LogList.vue?vue&type=script&lang=js&"
import style0 from "./Reward2LogList.vue?vue&type=style&index=0&id=c9768722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9768722",
  null
  
)

export default component.exports